export default __webpack_public_path__ + "static/media/ClassonThumbnailBlack1.22437a5c.png";